import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { reportIssue } from './api';

export interface IReportIssueState {
  status: 'idle' | 'loading' | 'rejected';
}

const initialState: IReportIssueState = {
  status: 'idle',
};

export const ReportIssueSlice = createSlice({
  name: 'reportIssue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reportIssue.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(reportIssue.fulfilled, (state) => {
        state.status = 'idle';
      })
      .addCase(reportIssue.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getReportIssueState = (
  state: RootState
): RootState['reportIssue'] => state.reportIssue;

export * from './api';
export default ReportIssueSlice.reducer;
